import {
  getCommcommunityAll,
  getPointLevelThreeListById,
  getPointTypeListPage
} from "@/api/point.js";
import {
  getPartsTypeListPage
} from "@/api/base.js";
export default {
  data() {
    return {
      commcommunityList: [],
      blockList: [],
      partsTypeList: [],
      pointTypeOptions: ['宣传公告','网格公示']
    }
  },
  mounted() {
    this.getCommcommunityAllFun()
    this.getPartsTypeListPageFun()
  },
  methods: {
    commcommunityChange(value) {
      this.getblockAllByCommunityIdFun(value);
    },
    // 社区列表
    async getCommcommunityAllFun() {
      const res = await getCommcommunityAll();
      this.commcommunityList = res.data.data;
    },
    // 网格列表
    async getblockAllByCommunityIdFun(id) {
      const res = await getPointLevelThreeListById({
        id: id
      });
      this.blockList = res.data.data;
    },
    // 网格列表
    async getPartsTypeListPageFun() {
      const res = await getPartsTypeListPage({
        enableStatus: 0,
        page: 1,
        size: 9999
      });
      this.partsTypeList = res.data.data.records;
    },

  }
}



// WEBPACK FOOTER //
// ./src/pages/streetInfo/publicNotice/index.js